(function () {
    'use strict';

    angular.module("imApp").factory("p2SubscriptionsEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getSubscriptionsEdit: function (parms) {
                return $ihttp.post({
                    method: 110,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
